export const BLE_PAIRING_GUID = 'blePairingGuid';
export const USB_CONNECTION_RETRY = 'usbConnectionRetry';
export const DEVICE_TYPE = 'deviceType';
export const SUCCESS_FWU_COUNT = 'successFwuCount';
